import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { useForm, useField } from 'react-final-form-hooks';

import useEffectFormReset from 'app/hooks/useEffectFormReset';
import useModal from 'app/hooks/useModal';
import { Input, Label, Button } from 'app/components';
import storage from 'app/services/session';

import {
  getPreValidationError,
  getPostValidationError
  // isFormDisabled
} from 'app/utils';
import { Page, Text, InputRow } from './styles';

const propTypes = {
  send: PropTypes.func.isRequired,
  validateWithSchema: PropTypes.func.isRequired,
  buyWithGift: PropTypes.func.isRequired,
  userSessionId: PropTypes.string,
  applyGiftcard: PropTypes.func.isRequired
};

const defaultProps = {
  userSessionId: null
};

const EmailConfirmation = ({ validateWithSchema, send, userSessionId, data, buyWithGift, isPayble, applyGiftcard }) => {
  const [t] = useTranslation();
  const [, , hideModal] = useModal('emailConfirmation');
  const [isErrored, setIsErrored] = useState(false);
  const isGiftcard = storage.getIsAppliedBonusGiftCard();

  const onSend = useCallback(
    ({ email }, form, notifyErrors) => {
      if (!isErrored) {
        hideModal();
        if (isGiftcard === 'true' && data && data?.length > 0) {
          if (isPayble === true) {
            buyWithGift(userSessionId, data, email, notifyErrors);
          } else {
            sessionStorage.setItem("email", email);
            applyGiftcard(userSessionId, data);
          }
        } else {
          storage.setIsAppliedBonusGiftCard(false)
          send(userSessionId, email, notifyErrors);
        }
      }
    },
    // eslint-disable-next-line
    [userSessionId, isErrored]
  );

  const { form, handleSubmit, submitErrors: errors, submitSucceeded, submitting } = useForm({
    onSubmit: onSend,
    validate: validateWithSchema
  });

  const handleConfirmation = (email, emailConfirm) => {
    setIsErrored(false);
    if (email === emailConfirm) {
      setIsErrored(false);
    } else {
      setIsErrored(true);
    }
  };

  const email = useField('email', form);
  const emailConfirm = useField('emailConfirm', form);

  // eslint-disable-next-line no-unneeded-ternary
  const isDisabled =
    emailConfirm.input.value === '' || email.input.value !== emailConfirm.input.value;

  useEffectFormReset(form, errors, submitSucceeded, submitting);

  return (
    <Page onSubmit={handleSubmit}>
      <Text>
        <strong>{t('purchase.email_confirmation.title')}</strong>
        <br />
        {t('purchase.email_confirmation.message')}
      </Text>
      <InputRow>
        <Label htmlFor={email.input.name}>{t('modals.forgot_password.email.label')}</Label>
        <Input
          {...email.input}
          placeholder="example@mail.com"
          onPaste={e => {
            e.preventDefault();

            return false;
          }}
          onCopy={e => {
            e.preventDefault();

            return false;
          }}
          onCut={e => {
            e.preventDefault();

            return false;
          }}
          id={email.input.name}
          error={
            getPreValidationError(email, t) || getPostValidationError(errors, email.input.name, t)
          }
        />
      </InputRow>
      <InputRow>
        <Label htmlFor={emailConfirm.input.name}>{t('modals.forgot_password.email.confirm')}</Label>
        <Input
          {...emailConfirm.input}
          placeholder="example@mail.com"
          id={emailConfirm.input.name}
          onPaste={e => {
            e.preventDefault();

            return false;
          }}
          onCopy={e => {
            e.preventDefault();

            return false;
          }}
          onCut={e => {
            e.preventDefault();

            return false;
          }}
          rules={{ required: true }}
          error={
            getPreValidationError(emailConfirm, t) ||
            getPostValidationError(errors, emailConfirm.input.name, t)
          }
          onBlur={() => handleConfirmation(email.input.value, emailConfirm.input.value)}
        />
      </InputRow>
      {isErrored && (
        <InputRow>
          <p style={{ color: 'red' }}>{t('modals.forgot_password.email.error')}</p>
        </InputRow>
      )}

      <Button type="submit" isPrimary disabled={isDisabled}>
        {t('common.submit')}
      </Button>
    </Page>
  );
};

EmailConfirmation.defaultProps = defaultProps;
EmailConfirmation.propTypes = propTypes;
export default EmailConfirmation;
